import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

// select allocation keys keyed by id
export const selectAllocationKeysData = createSelector(
  [(state: ApplicationState) => state.AllocationKeyStore.data],
  (data) => data
)

export const selectAllocationKeysFetched = createSelector(
  [(state: ApplicationState) => state.AllocationKeyStore.fetched],
  (fetched) => fetched
)
